import React from 'react'
import { Col, Form } from 'antd'
import { useTranslation } from 'lib/i18n'

import {
  VIDEO_REQUEST_OCCASION_ID,
  VIDEO_REQUEST_USAGE_OCCASION_IDS,
} from 'components/ProductPage/shared/FieldConstants'
import RequestOccasionCheckboxGroup from 'components/RequestOccasionCheckboxGroup/RequestOccasionCheckboxGroup'
import RequestOccasionSelect from 'components/RequestOccasionSelect/RequestOccasionSelect'

export default function Occasion(props) {
  const { t } = useTranslation()
  const { productType, label } = props

  const isBusinessRequest = productType === 'VIDEO_REQUEST_BUSINESS'

  const formItemName = isBusinessRequest
    ? VIDEO_REQUEST_USAGE_OCCASION_IDS
    : VIDEO_REQUEST_OCCASION_ID

  return (
    <Col span={24}>
      <Form.Item
        name={formItemName}
        rules={[
          {
            required: true,
            message: t(
              'VideoRequestForm.requestOccasionIdRequired',
              'You need to select an occasion',
            ),
          },
        ]}
        label={label}
      >
        {isBusinessRequest ? (
          <RequestOccasionCheckboxGroup {...props} />
        ) : (
          <RequestOccasionSelect {...props} />
        )}
      </Form.Item>
    </Col>
  )
}
